module.exports = __webpack_public_path__ + "img/goal-1.933cb796.jpg";